module.exports = __webpack_public_path__ + "media/components/icons/menu/Сервисы-a85d91ce9d73d7cc1e9185d37f74c35d.svg";